module.exports = __webpack_public_path__ + "static/media/mute_blue.730edb7d.svg";